import config from '../config';
import selectedEnvironment from '../env';

const baseURL = config[selectedEnvironment].API_URL;
const EXPORT_ROOT = `${baseURL}/TransactionDocumentsExport`;

const toMonthKey = (date) => {
  const y = date.getUTCFullYear();
  const m = String(date.getUTCMonth() + 1).padStart(2, '0');
  return `${y}-${m}`;
};

const buildExportDto = (accountantId, filters) => ({
  accountantId,
  fromMonthKey: filters.fromMonthKey ?? toMonthKey(filters.fromDate),
  toMonthKey: filters.toMonthKey ?? toMonthKey(filters.toDate),
  isActive: filters.active?.value ?? null,
  subAccIds: (filters.subAcc || []).map((o) => o.value),
  accMgmt: (filters.accMgmt || []).map((o) => o.value),
  reportingTypes: filters.reportingType ? [filters.reportingType.value] : [],
  vatReportStatuses: (filters.vatStatuses || []).map((o) => o.value),
  advanceReportStatuses: (filters.advanceStatuses || []).map((o) => o.value),
});

export const DownloadGeneratedDocumentsPdf = async (accountantId, filters, auth) => {
  const dto = buildExportDto(accountantId, filters);
  return fetch(`${EXPORT_ROOT}/accountant/generated-documents/pdf`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${auth}`,
    },
    body: JSON.stringify(dto),
  });
};

export const DownloadGeneratedDocumentsExcel = async (accountantId, filters, auth) => {
  const dto = buildExportDto(accountantId, filters);
  return fetch(`${EXPORT_ROOT}/accountant/generated-documents/excel`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${auth}`,
    },
    body: JSON.stringify(dto),
  });
};

export default {
  DownloadGeneratedDocumentsPdf,
  DownloadGeneratedDocumentsExcel,
  toMonthKey,
};
